/* global dataLayer: true */
/* eslint no-underscore-dangle: 0, camelcase: 0 */

if (typeof window !== `undefined`) {
  window.dataLayer = window.dataLayer || []
}

const sendEvent = (event, ga_category, ga_action, ga_label) => {
  // console.log('Analytics event >>', event, ga_category, ga_action, ga_label)
  dataLayer.push({ event, ga_category, ga_action, ga_label })
  // ga('send', 'event', ga_category, ga_action, ga_label);
}

const trackRegFormOpen = () => {
  sendEvent('open_reg_form', 'RegForm', 'open_form', 'Registration Form')
}

const trackLoginLinkClick = () => {
  sendEvent(
    'open_login_link_existing_email',
    'RegForm',
    'open_login_form',
    'Registration Form'
  )
}

const trackLoginFormOpen = () => {
  sendEvent('open_login_form', 'LoginForm', 'open_form', 'Login Form')
}

const trackRegFormNext = () => {
  sendEvent(
    'goto_next_reg_form',
    'RegForm',
    'goto_regform_next',
    'Registration Form'
  )
}

const trackRegFormSubmit = () => {
  sendEvent(
    'submit_reg_form',
    'RegForm',
    'submit_regform_next',
    'Registration Form'
  )
}

export {
  trackRegFormOpen,
  trackRegFormNext,
  trackRegFormSubmit,
  trackLoginFormOpen,
  trackLoginLinkClick,
}
